<article class="ref-dataset-card" (click)="onViewDetails()">
  <header
    class="ref-dataset-card__header ref-dataset-card__header--clickable"
    role="button"
    tabindex="0"
    [attr.aria-label]="'View details for ' + dataset.title"
    (click)="onViewDetails()"
    (keydown)="onHeaderKeydown($event)"
  >
    <h3 class="ref-dataset-card__title">{{ dataset.title }}</h3>
    <span
      *ngIf="dataset.problemStatement"
      class="ref-dataset-card__problem"
      [class.ref-dataset-card__problem--multiclass]="problemKind === 'multiclass'"
      [class.ref-dataset-card__problem--segmentation]="problemKind === 'segmentation'"
      [class.ref-dataset-card__problem--bounding-box]="problemKind === 'boundingBox'"
      [attr.title]="'Problem statement: ' + dataset.problemStatement"
    >
      <svg class="ref-dataset-card__problem__icon" width="12" height="12" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <ng-container [ngSwitch]="problemKind">
          <ng-container *ngSwitchCase="'multiclass'">
            <circle cx="12" cy="6" r="3"></circle>
            <circle cx="6" cy="17" r="3"></circle>
            <circle cx="18" cy="17" r="3"></circle>
          </ng-container>
          <ng-container *ngSwitchCase="'segmentation'">
            <path d="M3 9h18"></path>
            <path d="M3 15h18"></path>
            <path d="M9 3v18"></path>
            <path d="M15 3v18"></path>
          </ng-container>
          <ng-container *ngSwitchCase="'boundingBox'">
            <rect x="4" y="6" width="16" height="12" rx="1" stroke-dasharray="3 3"></rect>
          </ng-container>
          <ng-container *ngSwitchDefault>
            <circle cx="8" cy="12" r="4"></circle>
            <circle cx="16" cy="12" r="4"></circle>
          </ng-container>
        </ng-container>
      </svg>
      {{ dataset.problemStatement }}
    </span>
  </header>

  <div class="ref-dataset-card__body">
    <section class="ref-dataset-card__specs" aria-label="Dataset characteristics">
      <div class="ref-dataset-card__spec-card">
        <div class="ref-dataset-card__spec-head">
          <span class="ref-dataset-card__spec-icon ref-dataset-card__spec-icon--modality" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2"></rect>
              <circle cx="8.5" cy="8.5" r="1.5"></circle>
              <path d="M21 15l-5-5L5 21"></path>
            </svg>
          </span>
          <span class="ref-dataset-card__spec-label">Modality</span>
        </div>
        <p class="ref-dataset-card__spec-value">{{ dataset.modality }}</p>
      </div>
      <div class="ref-dataset-card__spec-card">
        <div class="ref-dataset-card__spec-head">
          <span class="ref-dataset-card__spec-icon ref-dataset-card__spec-icon--volume" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
            </svg>
          </span>
          <span class="ref-dataset-card__spec-label">Volume</span>
        </div>
        <p class="ref-dataset-card__spec-value">{{ dataset.volume }}</p>
      </div>
      <div class="ref-dataset-card__spec-card ref-dataset-card__spec-card--output">
        <div class="ref-dataset-card__spec-head">
          <span class="ref-dataset-card__spec-icon ref-dataset-card__spec-icon--output" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
            </svg>
          </span>
          <span class="ref-dataset-card__spec-label">Output</span>
        </div>
        <p class="ref-dataset-card__spec-value">{{ dataset.output }}</p>
      </div>
    </section>

    <section class="ref-dataset-card__metrics-row" aria-label="Competition metrics">
      <div
        *ngFor="let metric of dataset.primaryMetrics; let index = index"
        class="ref-dataset-card__metric-chip ref-dataset-card__metric-chip--primary"
      >
        <span class="ref-dataset-card__metric-chip-label">
          Primary metric{{ dataset.primaryMetrics.length > 1 ? ' ' + (index + 1) : '' }}
        </span>
        <span class="ref-dataset-card__metric-chip-value">{{ metric }}</span>
      </div>
      <div class="ref-dataset-card__metric-chip ref-dataset-card__metric-chip--secondary">
        <span class="ref-dataset-card__metric-chip-label">Secondary metric</span>
        <span class="ref-dataset-card__metric-chip-value">{{ dataset.secondaryMetric }}</span>
      </div>
    </section>
  </div>

  <div class="ref-dataset-card__actions" role="group" [attr.aria-label]="'Actions for ' + dataset.title" (click)="$event.stopPropagation()">
    <button
      type="button"
      class="ref-dataset-card__view-metrics-btn"
      (click)="onViewDetails($event)"
    >
      <span class="ref-dataset-card__view-metrics-btn-icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline points="14 2 14 8 20 8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
        </svg>
      </span>
      <span class="ref-dataset-card__view-metrics-btn-text">View details</span>
    </button>
    <button
      *ngIf="showSubmitModel"
      type="button"
      class="ref-dataset-card__action-btn ref-dataset-card__action-btn--primary"
      (click)="onSubmitModel($event)"
    >
      <span class="ref-dataset-card__action-btn-icon" aria-hidden="true">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="17 8 12 3 7 8"/>
          <line x1="12" y1="3" x2="12" y2="15"/>
        </svg>
      </span>
      <span class="ref-dataset-card__action-btn-text">Submit Model</span>
    </button>
  </div>
</article>
